import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "../../../utils/date";
import "./DatePicker.less";
import moment from "moment";

class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CustomStartDate: props.startDate,
      CustomEndDate: props.endDate,
      dateString: props.startDate + " - " + props.endDate
    };
    this.handleEvent = this.handleEvent.bind(this);
  }

  /**
   * onload call with latest props available
   * @param {*} newPros 
   */
  componentWillReceiveProps(newPros) {
    const props= this.props;
    if (
      newPros.startDate != props.startDate ||
      newPros.endDate != props.endDate
    ) {
      this.setState({
        CustomStartDate: newPros.startDate,
        CustomEndDate: newPros.endDate,
        dateString: newPros.startDate + " - " + newPros.endDate
      });
    }
  }

  /**
   * date conversion format function
   * @param {*} today 
   * @returns 
   */
  convertDateToFormat(today) {
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }

  /**
   * date change event handler
   * @param {*} event 
   * @param {*} picker 
   */
  handleEvent(event, picker) {
    const formattedStartDate = this.convertDateToFormat(picker.startDate._d);
    const formattedEndDate = this.convertDateToFormat(picker.endDate._d);
    const startEndDate = formattedStartDate + " - " + formattedEndDate;
    this.setState({
      CustomStartDate: formattedStartDate,
      CustomEndDate: formattedEndDate,
      dateString: startEndDate
    });
    this.props.onDateChange(formattedStartDate, formattedEndDate);
  }
  render() {
    return (
      <DateRangePicker
        startDate={this.state.CustomStartDate}
        endDate={this.state.CustomEndDate}
        maxDate={moment()
          .add(1, "month")
          .format("MM/DD/YYYY")}
        onEvent={this.handleEvent}
        showDropdowns
      >
        <input
          type={"text"}
          name={"dateRange"}
          className={"date-picker-range"}
          placeholder={"Select Date Range"}
          value={this.state.dateString}
        />{" "}
      </DateRangePicker>
    );
  }
}
export default DatePicker;
